export default "__VITE_ASSET__70cddbb7__"